import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectAccountId, selectApi } from '@socialive/common';
import { selectMediaUploadAssets } from '~/store/mediaUpload';
import updateStream from './updateStream';

export default createAsyncThunk(
  'recordings/fetchUploadedMediaAsset',
  async ({ sessionHash }, { getState, dispatch }) => {
    const api = selectApi(getState());
    const accountId = selectAccountId(getState());
    const asset = selectMediaUploadAssets(getState())[sessionHash];
    const query = `"${encodeURIComponent(asset.name)}"`;

    const { content } = await api(
      `/search/streams?q=title==${query};deletedAt=lt=1&sort=startedAt,desc&accountId=${accountId}`
    );

    const stream = { ...content[0], title: asset.originalName };

    await dispatch(updateStream({ id: stream.id, data: { title: asset.originalName } }));

    return stream;
  }
);
